import React, { Component } from "react";
import { Box } from "reactjs-admin-lte";
import {
  Pagination,
  Form,
  FormGroup,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import { momentHelper } from "../helpers";
import SelectDate from "component/element/SelectDate";
import Select from "react-select";
import PrintButtons from "component/element/PrintButtons";
import ReportStore from "stores/ReportStore";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import FontAwesome from "react-fontawesome";
import IframeModal from "component/element/IframeModal";
import Moment from "moment";
import "../report.css";
// import { connect } from 'react-redux';
const localStorageKey = "kkc.report-po";
class ReportPOStock extends Component {
  constructor(props) {
    super(props);
    const WHOLE_YEAR = momentHelper.getMonth(); //'00'
    const options = [
      { value: "car_registration_no", label: "ทะเบียนรถ" },
      { value: "shop_name", label: "ชื่อร้าน" },
      { value: "shop_vat", label: "เฉพาะร้านค้า VAT" },
      { value: "shop_nonvat", label: "เฉพาะร้านค้าไม่มี VAT" },
      { value: "item_part", label: "ค้นหาอะไหล่" },
    ];

    this.state = {
      loading: false,
      activePage: 1,
      month: "00",
      options: options,
      year: momentHelper.getYear(),
      data: [],
      day: "00",
      cat: "",
      query: "",
      placeholder: "",
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    if (newProps.show && newProps.show !== this.props.show) {
      this.loadData(
        this.state.year,
        this.state.month,
        this.state.day,
        this.state.cat,
        this.state.query
      );
      // this.loadSupplierList()
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth();
    if (all_day) {
      if (all_day < this.state.day) {
        var defaultDay = "00";
      } else {
        var defaultDay = this.state.day;
      }
    } else {
      var defaultDay = "00";
    }
    return defaultDay;
  }

  getNumberFormat(value) {
    let _val =
      value === "" || value === null || value === undefined || isNaN(value)
        ? 0
        : value;
    _val = parseFloat(_val);
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  }

  getSummary(field) {
    let { data } = this.state;
    let total = 0;
    data.forEach((item, index) => {
      total =
        total +
        (item[field] == "" ||
        item[field] == null ||
        item[field] == undefined ||
        isNaN(item[field])
          ? 0
          : parseFloat(item[field]));
    });
    return total;
  }

  loadData(year = "", month = "", day = "", cat = "", q = "") {
    ReportStore.loadReportPOStockItemByCar(
      year,
      month,
      day,
      cat,
      q,
      (result) => {
        this.setState({ data: result.data });
      }
    );
  }

  sumBalance(){
    let { data } = this.state;
    let sumBalance = 0;
    data.map((item,index)=>{
      sumBalance += item.balance_price
    })
    return sumBalance
  }

  renderBody() {
    let { data } = this.state;
    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={13}>ไม่พบข้อมูล</td>
        </tr>
      );
    } else {
      return data.map((item, index) => (
        <tr key={index}>
          <td className="text-center">{index + 1}</td>
          <td className="text-center">{item.productcode}</td>
          <td className="text-center">{item.detail}</td>
          <td className="text-left">{item.shop_name}</td>
          <td className="text-center">{item.in_q}</td>
          <td className="text-center">{item.out_q}</td>
          <td className="text-center">{item.balance_q}</td>
          <td className="text-right">{this.getNumberFormat(item.in_price)}</td>
          <td className="text-right">{this.getNumberFormat(item.out_price)}</td>
          <td className="text-right">
            {this.getNumberFormat(item.balance_price)}
          </td>
          <td className="text-center">{item.car_registration_no}</td>
          <td className="text-center">{item.insurance_name}</td>
          <td className="text-left">{item.purchase_order_no}</td>
          <td className="text-left">{item.taxinvoice_no}</td>
        </tr>
      ));
    }
  }

  getDate() {
    let { day, year, month } = this.state;
    let text = "ประจำวันที่ ";
    text += day + " " + momentHelper.getMonthText(month) + " " + year;
    if (year === "0" || year === "00" || year === 0) {
      text = "ทั้งหมด";
    } else if (month === "0" || month === "00" || month === 0) {
      text = "ประจำปี " + year;
    } else if (day === "0" || day === "00" || day === 0) {
      text = "ประจำเดือน " + momentHelper.getMonthText(month) + " " + year;
    }
    return text;
  }

  renderTable() {
    return (
      <div className="display-overflow">
        <table
          id={"report-po-stock"}
          className="table table-responsive table-hover table-bordered-solid"
          style={{ minWidth: "1400px" }}
        >
          <thead>
            <tr>
              <th
                style={{ display: "none" }}
                className="text-center"
                colSpan={13}
              >
                {"รายงาน Stock อะไหล่จาก PO ตัดเข้ารถยนต์ "}
                {this.getDate()}
              </th>
            </tr>
            <tr>
              <th className="text-center" style={{ width: "20px" }} rowSpan={2}>
                ลำดับ
              </th>
              <th className="text-center" style={{ width: "90px" }} rowSpan={2}>
                รหัสสินค้า
              </th>
              <th
                className="text-center"
                style={{ width: "100px" }}
                rowSpan={2}
              >
                ชื่ออะไหล่
              </th>
              <th
                className="text-center"
                style={{ width: "170px" }}
                rowSpan={2}
              >
                ชื่อร้านค้า
              </th>
              <th className="text-center" style={{ width: "50px" }} colSpan={3}>
                จำนวน(สินค้า)
              </th>
              <th className="text-center" style={{ width: "80px" }} colSpan={3}>
                มูลค่าสินค้า
              </th>
              <th className="text-center" style={{ width: "80px" }} rowSpan={2}>
                ทะเบียน
              </th>
              <th className="text-center" style={{ width: "80px" }} rowSpan={2}>
                ประกันภัย
              </th>
              <th className="text-center" style={{ width: "80px" }} rowSpan={2}>
                หมายเหตู
              </th>
              <th className="text-center" style={{ width: "80px" }} rowSpan={2}>
                ใบกำกับภาษี
              </th>
            </tr>
            <tr>
              <th className="text-center" style={{ width: "80px" }}>
                เข้า
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ออก
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                คงเหลือ
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                เข้า
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                ออก
              </th>
              <th className="text-center" style={{ width: "80px" }}>
                คงเหลือ
              </th>
            </tr>
          </thead>
          <tbody>{this.renderBody()}</tbody>
          <tfoot>
            <tr>
                <th className="text-right" colSpan={9}>รวมมูลค่าคงเหลือ</th>
                <th className="text-right"> {this.getNumberFormat(this.sumBalance())}</th>
                <th colSpan={4}></th>
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey,
    });
    // next... load new page
  }

  onDayChange(val) {
    this.setState({
      day: val.value,
      isRange: false,
    });
    this.loadData(
      this.state.year,
      this.state.month,
      val.value,
      this.state.cat,
      this.state.query
    );
  }

  onMonthChange(val) {
    let date = this.state.year - 543 + "-" + val.value;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      month: val.value,
      isRange: false,
      day: _day,
    });
    this.loadData(
      this.state.year,
      val.value,
      _day,
      this.state.cat,
      this.state.query
    );
  }

  onYearChange(val) {
    let date = val.value - 543 + "-" + this.state.month;
    let _day = "00";
    _day = this.getAllDayOfMonth(date);
    this.setState({
      year: val.value,
      isRange: false,
      day: _day,
    });
    this.loadData(
      val.value,
      this.state.month,
      _day,
      this.state.cat,
      this.state.query
    );
  }

  onTextChange(e) {
    this.setState({ query: e.target.value });
  }

  onSearchKeyPress(e) {
    if (e.charCode === 13) {
      this.onSearchClick();
    }
  }
  onTypeChange(e) {
    let { cat,year,month,day,query } = this.state;
    cat = e.value;
    this.setState({
      cat: cat,
      placeholder: e.label,
    });
    
    this.loadData(
      year,
      month,
      day,
      cat,
      query
    );
  }

  onSearchClick(e) {
    let { year, month, day, query, cat } = this.state;
    this.loadData(year, month, day, cat, query);
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(
      document.getElementById("report-po-stock")
    );
    let wbout = XLSX.write(worksheet, {
      bookType: "xlsx",
      bookSST: true,
      type: "binary",
    });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    }
    const fileName = "รายงาน Stock อะไหล่จาก PO ตัดเข้ารถยนต์.xlsx";
    FileSaver.saveAs(
      new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
      fileName
    );
    this.setState({ showExport: false });
  }

  renderToolbar() {
    return (
      <Form inline>
        <FormGroup style={{ verticalAlign: "top" }}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
          />
        </FormGroup>{" "}
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.cat}
            options={this.state.options}
            style={{ width: "150px" }}
            onChange={this.onTypeChange.bind(this)}
          />
        </FormGroup>{" "}
        <FormGroup>
          <InputGroup>
            <InputGroup>
              <FormControl
                value={this.state.query}
                placeholder={this.state.placeholder}
                onChange={this.onTextChange.bind(this)}
                onKeyPress={this.onSearchKeyPress.bind(this)}
              />
              <InputGroup.Addon
                className="btn"
                onClick={this.onSearchClick.bind(this)}
              >
                <FontAwesome name="search" />
              </InputGroup.Addon>
            </InputGroup>
          </InputGroup>
        </FormGroup>
        <FormGroup
          style={{
            verticalAlign: "top",
            marginLeft: "5px",
            marginTop: "1.5px",
          }}
        >
          <PrintButtons
            // onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft="0"
            width="auto"
          />
        </FormGroup>
      </Form>
    );
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)}
        />
      </div>
    );
  }

  render() {
    return (
      <Box>
        <Box.Header border={true}>{this.props.renderMenu()}</Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}          
          {/*this.renderPaging()*/}
          <IframeModal ref="iframe" title={"พิมพ์เอกสาร"} />
        </Box.Body>
      </Box>
    );
  }
}

ReportPOStock.defaultProps = {
  show: false,
  type: "received",
};

export default ReportPOStock;



// WEBPACK FOOTER //
// ./src/view/report/po/ReportPOStock.js